import { css } from 'styled-components';

// Named app sizes remain available; numeric sizes preserve prototype values.
const SIZES = Object.freeze({
  xs: 'var(--ex-font-size-xs)',
  s: 'var(--font-size-s)',
  m: 'var(--font-size-m)',
  l: 'var(--font-size-l)',
  xl: 'var(--font-size-xl)',
  xxl: 'var(--font-size-xxl)',
});

const WEIGHTS = Object.freeze([400, 500, 600, 700, 800]);

/** exFont(600, 'm') → IBM Plex Sans, weight 600, --font-size-m. */
export const exFont = (weight = 400, size = 'm') => css`
  font-family: var(--ex-font-family, var(--font-family-ibm_plex_sans));
  font-weight: ${WEIGHTS.includes(weight) ? weight : 400};
  font-size: ${Number.isFinite(size) && size > 0
    ? `${size}px`
    : SIZES[size] || SIZES.m};
  font-style: normal;
`;
